import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import MobileNavBar from "./MobileNavBar";

import { menuList } from "../../data/menuList/MenuData";
import { FaChevronDown } from "react-icons/fa";
import ichLogo from "../../assets/images/IchName/ichwhite.svg"

const SecondNavBar: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [screenSize, setScreenSize] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });
  const menuRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const clickScroller = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleResize = useCallback(() => {
    const width = window.innerWidth;
    setScreenSize({
      isMobile: width <= 720,
      isTablet: width > 720 && width <= 1119,
      isDesktop: width >= 1120,
    });
  }, []);

  const handleScroll = useCallback(() => {
    if (screenSize.isTablet) {
      // Always visible on tablet
      setIsVisible(true);
      return;
    }

    const scrollY = window.scrollY;
    const firstSection = document.getElementById("first-section");
    const firstSectionHeight = firstSection?.offsetHeight || 200;

    setIsVisible(scrollY >= firstSectionHeight);
  }, [screenSize.isTablet]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check
    handleScroll();
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [handleScroll, handleResize]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div className="mb-16 xl:mb-0 block xl:hidden">
        <MobileNavBar />
      </div>

      <div className="xl:block hidden">
        {(screenSize.isTablet || (screenSize.isDesktop && isVisible)) && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className={`${screenSize.isTablet ? "fixed" : "fixed"
              } top-0 left-0 right-0 z-50 bg-white shadow-md`}
          >
            <div className="w-full px-4 sm:px-6">
              <div className="flex items-center justify-between py-4 lg:px-6 mx-auto max-w-full ">
                <div className="absolute  inset-0 -z-10  md:w-64 lg:w-80 xl:w-3/12 bg-green-500">
                  <div className="border-r-[40px] border-t-[75px] border-t-transparent border-r-gray-300"></div>
                </div>


                <img src={ichLogo} alt="CeylonHospital" width={200} height={200} />
                {/* <div className="lg:w-3/12 text-white text-2xl sm:text-3xl font-bold Blinker-Bold ">
                  Ceylon Hospital
                </div> */}

                {/* <div className="hidden md:flex  gap-1 lg:gap-4 lg:w-8/12 justify-center">
                  {menuList.map((item) => (
                    <div key={item.id} className="relative group">
                      <div className="flex items-center">
                        <Link
                          to={item.url}
                          className={`px-3 py-2 font-medium transition-all duration-200 Blinker-SemiBold ${
                            location.pathname === item.url
                              ? "text-green-700  rounded-lg"
                              : "text-gray-700 hover:text-green-700"
                          }`}
                          onClick={clickScroller}
                          aria-current={
                            location.pathname === item.url ? "page" : undefined
                          }
                        >
                          <div className="flex flex-row items-center">
                            {item.name}
                            {item.submenu && (
                              <span className="ml-1 text-gray-500 group-hover:text-green-600 transition-colors duration-200">
                                <FaChevronDown size={12} />
                              </span>
                            )}
                          </div>
                        </Link>
                      </div>

                      {item.submenu && (
                        <div className="absolute left-1/2 transform -translate-x-1/2 mt-0 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible group-hover:mt-2 transition-all duration-200">
                          {item.submenu.map((subItem) => (
                            <Link
                              key={subItem.id}
                              to={subItem.url}
                              className={`block px-4 py-2 text-sm Blinker-Regular ${
                                location.pathname === subItem.url
                                  ? "bg-green-100 text-green-700 font-medium"
                                  : "text-gray-700 hover:bg-green-50 hover:text-green-700"
                              }transition-colors`}
                              onClick={clickScroller}
                            >
                              {subItem.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div> */}

                <div className="hidden md:flex gap-1 lg:gap-4 lg:w-8/12 justify-center">
                  {menuList.map((item) => {
                    const isActive = location.pathname === item.url ||
                      (item.submenu && item.submenu.some(subItem =>
                        location.pathname === subItem.url
                      ));

                    return (
                      <div key={item.id} className="relative group">
                        <div className="flex items-center">
                          <Link
                            to={item.url || "#"}
                            className={`px-3 py-2 font-medium transition-all duration-200 Blinker-SemiBold ${isActive
                              ? "text-green-700 rounded-lg"
                              : "text-gray-700 hover:text-green-700"
                              }`}
                            onClick={clickScroller}
                            aria-current={isActive ? "page" : undefined}
                          >
                            <div className="flex flex-row items-center">
                              {item.name}
                              {item.submenu && (
                                <span className={`ml-1 transition-colors duration-200 ${isActive
                                  ? "text-green-700"
                                  : "text-gray-500 group-hover:text-green-600"
                                  }`}>
                                  <FaChevronDown size={12} />
                                </span>
                              )}
                            </div>
                          </Link>
                        </div>

                        {item.submenu && (
                          <div className="absolute left-1/2 transform -translate-x-1/2 mt-0 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible group-hover:mt-2 transition-all duration-200">
                            {item.submenu.map((subItem) => (
                              <Link
                                key={subItem.id}
                                to={subItem.url}
                                className={`block px-4 py-2 text-sm Blinker-Regular ${location.pathname === subItem.url
                                  ? "bg-green-100 text-green-700 font-medium"
                                  : "text-gray-700 hover:bg-green-50 hover:text-green-700"
                                  } transition-colors`}
                                onClick={clickScroller}
                              >
                                {subItem.name}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>



                <div className="lg:w-2/12 hidden md:block">
                  <Link to={"/book-appointment"}>
                    <button
                      onClick={clickScroller}
                      className="bg-green-500 text-[.8rem] lg:text-xs text-white py-2 px-5 rounded-md hover:opacity-85 Blinker-SemiBold"
                    >
                      Book Appointment
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </>
  );
};

export default SecondNavBar;

